<template>
  <div class="big_box4">
    <div class="top_title3">
      <h4>文化事业建设费申报表</h4>
      <div class="bottom_font clearfix">
        <h6 class="left">纳税人名称：<span>{{comName}}</span></h6>
        <h6 class="center">税款所属期：<span>{{durationOfTaxTime}}</span></h6>
        <h6 class="right">
          <p>单位：元</p>
          <p>纳税人识别号：<span>{{taxNo}}</span></p>
        </h6>
      </div>
    </div>
    <table class="content" cellspacing="0">
      <tr class="top_bg">
        <td colspan="3" class="center weight" style="width:60%;">项目</td>
        <td class="center weight" style="width:8%;">栏次</td>
        <td class="center weight" style="width:16%;">本期数</td>
        <td class="center weight" style="width:16%;">本年累计</td>
      </tr>
      <tr>
        <td rowspan="2" style="width:12%;">计费收入</td>
        <td colspan="2">应征收入</td>
        <td class="center">1</td>
        <qzf-td :disabled="false" v-model:amount="list.yzsrbys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.yzsrbnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td colspan="2">免征收入</td>
        <td class="center">2</td>
        <qzf-td :disabled="false" v-model:amount="list.mzsrbys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.mzsrbnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td rowspan="8">费率计算</td>
        <td colspan="2">扣除项目期初金额</td>
        <td class="center">3</td>
        <qzf-td :disabled="false" v-model:amount="list.jcxmqcjeBys" @change="changeList()"></qzf-td>
        <td class="center">----</td>
      </tr>
      <tr>
        <td colspan="2">扣除项目本期发生额</td>
        <td class="center">4</td>
        <qzf-td :disabled="false" v-model:amount="list.jcxmbqfseBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.jcxmbqfseBnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td rowspan="2">本期减除额</td>
        <td>应征收入减除额</td>
        <td class="center">5</td>
        <qzf-td :disabled="false" v-model:amount="list.yzsrjceBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.yzsrjceBys" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td>免征收入减除额</td>
        <td class="center">6</td>
        <qzf-td :disabled="false" v-model:amount="list.mzsrjceBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.mzsrjceBnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td colspan="2">扣除项目期末余额</td>
        <td class="center">7=3+4-5-6</td>
        <qzf-td :disabled="false" v-model:amount="list.jcxmqmyeBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.jcxmqmyeBnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td colspan="2">计费销售额</td>
        <td class="center">8=1-5</td>
        <qzf-td :disabled="false" v-model:amount="list.jfxseBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.jfxsebnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td colspan="2">费率</td>
        <td class="center">9</td>
        <td class="center">0.03</td>
        <td class="center">----</td>
      </tr>
      <tr>
        <td colspan="2">应缴费额</td>
        <td class="center">10=8×9</td>
        <qzf-td :disabled="false" v-model:amount="list.yjfeBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.yjfebnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td rowspan="9">费额缴纳</td>
        <td colspan="2">期初未缴费额（多为负数）</td>
        <td class="center">11</td>
        <qzf-td :disabled="false" v-model:amount="list.qcwjfeDjwfBys" @change="changeList()"></qzf-td>
        <td class="center">----</td>
      </tr>
      <tr>
        <td colspan="2">本期已缴费额</td>
        <td class="center">12=13+14+15</td>
        <qzf-td :disabled="false" v-model:amount="list.bqyjfeBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.bqyjfebnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td colspan="2">其中：本期预缴费额</td>
        <td class="center">13</td>
        <qzf-td :disabled="false" v-model:amount="list.qzbqyjfeBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.bqyjfebnlj1" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td colspan="2">本期缴纳上期费额</td>
        <td class="center">14</td>
        <qzf-td :disabled="false" v-model:amount="list.qzbqjnsqfeBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.bqjnsqfebnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td colspan="2">本期缴纳欠费额</td>
        <td class="center">15</td>
        <qzf-td :disabled="false" v-model:amount="list.qzbqjnqfeBys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.bqjnqfebnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td colspan="2">期末未缴费额（多为负数）</td>
        <td class="center">16=10+11-12</td>
        <qzf-td :disabled="false" v-model:amount="list.qmwjfebys" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.qmwjfedjwfbnlj" @change="changeList()"></qzf-td>
      </tr>
      <tr>
        <td colspan="2">其中：欠缴费额（≥0）</td>
        <td class="center">17=11-14-15</td>
        <qzf-td :disabled="false" v-model:amount="list.qzqjfe" @change="changeList()"></qzf-td>
        <td class="center">----</td>
      </tr>
      <tr>
        <td colspan="2">本期应补（退）费额</td>
        <td class="center">18=10*(1-减征比例)-13</td>
        <qzf-td :disabled="false" v-model:amount="list.bqybtfe"></qzf-td>
        <td class="center">----</td>
      </tr>
      <tr>
        <td colspan="2">本期检查已补缴费额</td>
        <td class="center">19</td>
        <qzf-td :disabled="false" v-model:amount="list.bqjcybjfe" @change="changeList()"></qzf-td>
        <qzf-td :disabled="false" v-model:amount="list.bqjcybjfeBnlj" @change="changeList()"></qzf-td>
      </tr>

      
    </table>
  </div>
  <div class="save_box">
    <el-button type="primary" @click="saveValues()" size="small" plain>保存</el-button>
  </div>
</template>

<script>
import { gsInfo , gsEdit} from '@/api/taxCalculation.js'
export default {
  name: 'culturalMain',
  data() {
    return {
      durationOfTaxTime: '',
      activeName: '1',
      name: '1',
      listQuery: {},
      list: {},
      attachArr: [],
      comName:this.$store.getters['user/comInfo'].comName,
      taxNo:this.$store.getters['user/comInfo'].taxNo,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 公式
    changeList(){
      this.list.bqybtfe = (this.list.yjfeBys*0.5 - this.list.qzbqyjfeBys).toFixed(2)*1
    },
    getList(){
      gsInfo({tableName: 'gs_whsyjsfsbbygz',itemName:'main'}).then(res=>{
        if(res.data.data.info){
          this.list = res.data.data.info
          this.durationOfTaxTime = res.data.data.time
        }
      })
    },
    saveValues(){
      let param = {
        tableName:'gs_whsyjsfsbbygz',
        itemName:'main',
        items: [this.list]
      }
      gsEdit(param).then(res => {
        if(res.data.msg == "success") {
          this.$qzfMessage("保存成功")
          this.getList()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 180px !important;
}
.save_box{
  margin: 0 auto;
  margin-top: 30px;
  text-align: center;
}
.center{
  text-align: center;
  color: #333 !important;
}
.weight{
  font-size: 14px !important;
}
.left{
  text-align: left;
}
.right{
  text-align: right;
}
.left_k{
  text-indent: 41px;
}
.content{
  // width: 2000px;
  width: 100%;
  margin: 0 auto;
  border:1px solid #c2c2c2;
  border-bottom: none;
  border-right: none;
  margin-top: 10px;
  span{
    line-height: 26px;
    font-size: 14px;
  }
  tr{
    padding: 0;
    margin: 0;
  }
  td{
    border-right:1px solid #c2c2c2;
    border-bottom:1px solid #c2c2c2;
    line-height: 26px;
    padding:0 6px;
    color: #333;
    font-size: 14px;
  }
  input{
    width: 100%;
    line-height: 26px;
    padding: 0 6px;
    font-size: 14px;
    // text-align: right;
    // padding-right: 12px;
  }
}
.top_title3{
  width: 100%;
  margin: 0 auto;
  h4{
    font-size: 20px;
    color: #333;
    font-weight: 600;
    text-align: center;
  }
  h5{
    font-size: 16px;
    color: #333;
    font-weight: normal;
    text-align: center;
    margin-top: 10px;
  }
  .bottom_font{
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    h6{
      float: left;
      width: 33.33%;
      font-size: 14px;
      color: #333;
      font-weight: normal;
    }
    h6:nth-child(1){
      padding-top: 10px;
    }
    h6:nth-child(2  ){
      padding-top: 10px;
    }
  }
}

.big_box4{
  width: 98%;
  // padding: 40px;
  background: #fff;
  // box-shadow: 0 2px 10px #ddd;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: auto;
}
.right_box {
  // float: right;
  width:25%;
  text-align: right;
  margin-bottom: 15px;
  margin-right: 16px;
  position: absolute;
  top: 0;
  right: 3px;
  
}
</style>